import axios from "axios";

import Config from "../../config";

const actionDeletarWebhook = (webhookId) => {

    return axios({
        method: "delete",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/clientes/cliente/integracoes/webhooks/${webhookId}/deletar`
    });
};

export default actionDeletarWebhook;
